import * as actionTypes from "./actionTypes";

export const getAllTeams = (allTeam) => {
  return {
    type: actionTypes.GET_ALL_TEAMS,
    allTeam: allTeam,
  };
};

export const storeSearchTName = (name) => {
  return {
    type: actionTypes.SAVE_SEARCH_TNAME,
    name: name,
  };
};

export const clearSearchTName = () => {
  return {
    type: actionTypes.CLEAR_SEARCH_TNAME,
  };
};

export const storeTSort = (sort) => {
  return {
    type: actionTypes.SAVE_SORT,
    sort: sort,
  };
};

export const updateTeam = (singleTeam) => {
  return {
    type: actionTypes.UPDATE_TEAM,
    team: singleTeam,
  };
};

export const createTeam = (singleTeam) => {
  return {
    type: actionTypes.CREATE_TEAM,
    team: singleTeam,
  };
};

export const deleteTeam = (singleTeam) => {
  return {
    type: actionTypes.DELETE_TEAM,
    team: singleTeam,
  };
};

export const clearAllTeams = () => {
  return {
    type: actionTypes.CLEAR_ALL_TEAMS,
  };
};
